import Http from '@/utils/http';
import { AppResponse, PracticeReportResResult, IReportData, IMockRankingList } from '@/types';

// 练习报告
export const getPracticeReport = (params: { paperDataLogId: number }): Promise<AppResponse<PracticeReportResResult>> =>
    Http.post('minerva/api/v1/front/question-report', params);

// 考试报告
export const getPaperReport = (params: { paperDataLogId: number; needReviewInfo: number }): Promise<AppResponse<IReportData>> =>
    Http.post('minerva/api/v1/front/exam-report', params);

// 模拟考试报告
export const getMockPaperReport = (params: { paperDataLogId?: number; simulationId: number }): Promise<AppResponse<IReportData>> =>
    Http.post('minerva/api/v1/front/simulation-exam/exam-report', params);

// 模拟考试报告
export const getMockRankingList = (params: { simulationExamId: number }): Promise<AppResponse<IMockRankingList>> =>
    Http.get('minerva/api/v1/front/simulation-exam/rank', params);

// 获取是否展示能量赠送弹窗
export const getAiActivityInfo = (params: {
    capacityId: number; // 能力菜单id ：7课程-试卷 8课程-课中答题 9课程考点图谱 10题库-试卷 11题库-练习
    paperDataLogId: number; // paperDataLogId
    projectId: number; // 项目id
    subjectId: number; // 科目id
    courseId?: number; // 课程id
    sourceType: number; // 平台来源：100536074 学习平台；100536073 中台；100536072 教务 100536075 公考"
    tutorId: number; // 来源端场景id，1课程，2题库，3公考
}): Promise<
    AppResponse<{
        displayContent: string; // 备注：展示文案
        giveEnergyStatus: number; // 备注：是否赠送能量 0 不赠送 1 赠送
        channelType: number; // 弹窗类型，根据不同行为跳转逻辑不同
    }>
> => Http.post('/aitutor/api/v1/front/activity-give-energy', { ...params, openEnergyToEquity: 1 });

// 获取是否展示运营弹窗
export const getShowCpaModalInfo = (params: {
    practiceScene: number; // 练习场景 1：课程练习，2：题库练习，3：进入题库页面进行能量值有效期判断
    projectId: number;
    source: number; // 来源 1：APP 2：PC
    subjectId: number; // 科目id
}): Promise<
    AppResponse<{
        buttonTip: string; // 按钮文案
        link: string; // 跳转链接
        secondTip: string; // 副提示语
        showPopup: number; // 0：什么都不做，1：弹窗
        tip: string; // 主提示语
        useCorrectStatus: number; // 是否使用过ai批改 0未使用 1 使用过
    }>
> => Http.post('/evaluation/api/v1/correct/popup-rule', { ...params, openEnergyToEquity: 1 });
